import styled from 'styled-components';
import ds, { media } from 'designsystem';

const Language = styled.a`
  color: ${ds.brand('text')};
  cursor: pointer;
  font-size: ${ds.fontSize('s')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  text-decoration:none;
  padding: ${ds.get('metrics.xs')} ${ds.get('metrics.s')} ${ds.get('metrics.xs')} 0;
  user-select: none;
  
  ${({ active }) => (active ? `font-weight: ${ds.get('type.fontWeight.bold')};` : '')}
  
  ${media.desktop`
    padding: 0;
    margin: calc(${ds.get('metrics.xs')} + 2px) ${ds.get('metrics.s')} ${ds.get('metrics.xs')} 0;
    position: relative;
  `}
`;

export default Language;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/Language.jsx